import { React, useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import DashBoardNavbar from "../Components/DashBoardNavbar";
import HomePageNavbarFinancials from "../Components/HomePageNavbarFinancials";
import axios from "axios";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import Loading from "../Components/Loading";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";

function SALESREPORTDETAILED() {
  const BASEURL = process.env.REACT_APP_BASEURL;
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const divisionState = useSelector((state) => state.changeDivision);
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const [receipts, setReciepts] = useState([]);
  const [isoading, setisloading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const currentDate = new Date();
  const startOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1,
  );
  const localStartOfMonth = new Date(
    startOfMonth.getTime() - startOfMonth.getTimezoneOffset() * 60000,
  );
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState(localStartOfMonth.toISOString());
  const [toDate, setToDate] = useState(currentDate.toISOString());
  const [paymodes, setPaymodes] = useState([]);
  const [selpaymentmode, setselpaymentmode] = useState("");

  useEffect(() => {
    fetchReceipts();
  }, []);

  const filtData = receipts.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);
    const sDate = item.CREATEDDATE;
    const eDate = item.CREATEDDATE;

    if (searchData?.length === 0 && !fromDate && !toDate) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "SALETYPE",
        "CLIENT",
        "DIVISION",
        "BILLNO",
        "TABLENO",
        "WAITER",
        "SHIFT",
        "SALEHOUR",
        "CASHIER",
        "CURRENCY",
        "ITEMNAME",
        "ITEMCODE",
        "CATEGORY",
        "SUBCATEGORY",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    const dateMatch =
      (!fromDate || sDate >= fromDate) && (!toDate || eDate <= toDate);

    return dateMatch && textMatch;
  });

  useEffect(() => {
    let total = 0;
    filtData.forEach((item) => {
      total += parseFloat(item.AMOUNT);
    });
    setTotalAmount(total);
  }, [filtData]);

  const customStyless = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      minWidth: "200px",
      maxWidth: "200px",
      marginTop: "0px",
      minHeight: "initial",
      height: "30px",
      border: "1px solid",
      paddingBottom: "0px",
      paddingTop: "0px",
      marginLeft: "0px",
      backgroundColor: "white",
      color: "black",
      textTransform: "uppercase",
      "@media (max-width: 720px)": {
        minWidth: "181px",
      },
    }),
  };

  const Excelreceipt = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Collection Report");
    const rows = document.querySelectorAll(".table_1 tbody tr");

    const columnWidths = [15, 25, 20, 15, 15, 25, 10, 15, 25,20,20,30, 15, 15, 15, 15];

    // Set column widths for the worksheet
    columnWidths.forEach((width, index) => {
      worksheet.getColumn(index + 1).width = width;
    });

    // Add headers
    const headerRow = worksheet.addRow([
           "SALE TYPE",
      "CLIENT",
      "DIVISION",
      "BILL NO",
      "TABLE NO",
      "WAITER",
      "CREATED DATE",
      "DATE TIME",
      "SHIFT",
      "SALE HOUR",
      "AMOUNT",
      "LEVY AMOUNT",
      "VAT AMOUNT",
      "CASH AMOUNT",
      "MPESA AMOUNT",
      "CREDIT CARD AMOUNT",
      "RECEIPT AMOUNT",
      "CASHIER",
      "CURRENCY",
      "CATEGORY",
      "SUB CATEGORY",
      "ITEM CODE",
      "ITEM NAME",
      "RATE INCLUSIVE",
      "QTY",
      "ITEM VAT AMOUNT",
      "ITEM LEVY AMOUNT",
      "ITEM VALUE EXC VAT",
      "ITEM VALUE",
    ]);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    // Add rows from the table
    rows.forEach((row) => {
      const rowData = [];
      row.querySelectorAll("td").forEach((cell) => {
        rowData.push(cell.textContent);
      });
      worksheet.addRow(rowData);
    });

    // Create a blob from the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Collection_Report.xlsx";
      link.click();
    });
  };

  const PdfReceipts = () => {
    const doc = new jsPDF();

    doc.text("Collections Report", 10, 10);

    const columns = [
      "SALE TYPE",
      "CLIENT",
      "DIVISION",
      "BILL NO",
      "TABLE NO",
      "WAITER",
      "CREATED DATE",
      "DATE TIME",
      "SHIFT",
      "SALE HOUR",
      "AMOUNT",
      "LEVY AMOUNT",
      "VAT AMOUNT",
      "CASH AMOUNT",
      "MPESA AMOUNT",
      "CREDIT CARD AMOUNT",
      "RECEIPT AMOUNT",
      "CASHIER",
      "CURRENCY",
      "CATEGORY",
      "SUB CATEGORY",
      "ITEM CODE",
      "ITEM NAME",
      "RATE INCLUSIVE",
      "QTY",
      "ITEM VAT AMOUNT",
      "ITEM LEVY AMOUNT",
      "ITEM VALUE EXC VAT",
      "ITEM VALUE",
    ];
    const data = filtData.map((stock) => [
      stock.SALETYPE,
      stock.CLIENT,
      stock.DIVISION,
      stock.BILLNO,
      stock.TABLENO,
      stock.WAITER,
      moment(stock.CREATEDDATE).format("DD/MM/YYYY"),
      moment(stock.DATETIME).format("DD/MM/YYYY HH:mm:ss"),
      stock.SHIFT,
      stock.SALEHOUR,
      stock.AMOUNT,
      stock.LEVYAMOUNT,
      stock.VATAMOUNT,
      stock.CASHAMOUNT,
      stock.MPESAMOUNT,
      stock.CREDITCARDAMOUNT,
      stock.RECEIPTAMOUNT,
      stock.CASHIER,
      stock.CURRENCY,
      stock.CATEGORY,
      stock.SUBCATEGORY,
      stock.ITEMCODE,
      stock.ITEMNAME,
      stock.RATEINCLUSIVE,
      stock.QTY,
      stock.ITEMVATAMOUNT,
      stock.ITEMLEVYAMOUNT,
      stock.ITEMVALUEEXCVAT,
      stock.ITEMVALUE,
    ]);

    doc.autoTable({
      head: [columns],
      body: data,
      startY: 20,
      showHead: "firstPage",
    });

    doc.save("Collections_Report.pdf");
  };

  function fetchReceipts() {
    setisloading(true);

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1846`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setReciepts(response.data);
        setisloading(false);
      })
      .catch((err) => {
        console.log(err);
        setisloading(false);
      });
  }

  const renderList = (
    <>
      <section className="lg:flex justify-between">
        <div className="flex items-center mx-8 justify-between mt-3 gap-5">
          <p className="">Search:</p>
          <input
            className="w-64 h-6 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
            type="text"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
          <div>
            <label>From Date:</label>
            <input
              type="date"
              value={fromDate.split("T")[0]}
              onChange={(e) => setFromDate(e.target.value)}
              className="w-35 h-8 border border-black ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
            />
          </div>
          <div>
            <label>To Date:</label>
            <input
              type="date"
              value={toDate.split("T")[0]}
              onChange={(e) => setToDate(e.target.value)}
              className="w-35 h-8 border border-black ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
            />
          </div>
        </div>
        <div className="flex items-center mx-8 justify-between mt-3 gap-5">
          <div className="flex items-center">
            <div>
              <RiFileExcel2Line onClick={Excelreceipt} size={35} />
            </div>
            <div>
              {" "}
              <BsFileEarmarkPdf onClick={PdfReceipts} size={35} />
            </div>
          </div>
        </div>
      </section>
      <aside className="table__pos__app ">
        <table class="custom-table table_1">
          <thead class="header-cell">
            <td className="text-left">SALES TYPE</td>
            <td className="text-left">CLIENT</td>
            <td className="text-left">DIVISON</td>
            <td className="text-right">BILL NO</td>
            <td className="text-left">TABLE NO</td>
            <td className="text-left">WAITER</td>
            <td className="text-left">CREATED DATE</td>
            <td className="text-left">DATE TIME</td>
            <td className="text-right">SHIFT</td>
            <td className="text-right">SALE HOURS</td>
            <td className="text-right">AMOUNT</td>
            <td className="text-right">LEVY AMOUNT</td>
            <td className="text-right">VAT AMOUNT</td>
            <td className="text-right">CASH AMOUNT</td>
            <td className="text-right">MPESA AMOUNT</td>
            <td className="text-right">CREDIT CARD AMOUNT</td>
            <td className="text-right">RECEIPT AMOUNT</td>
            <td className="text-right">CASHIER</td>
            <td className="text-right">CURRENCY</td>
            <td className="text-left">CATEGORY</td>
            <td className="text-left">SUB CATEGORY</td>
            <td className="text-left">ITEM CODE</td>
            <td className="text-left">ITEM NAME</td>
            <td className="text-right">RATE INCLUSIVE</td>
            <td className="text-right">QTY</td>
            <td className="text-right">ITEM VAT AMOUNT</td>
            <td className="text-right">ITEM LEVY AMOUNT</td>
            <td className="text-right">ITEM VALUE EXC VAT</td>
            <td className="text-right">ITEM VALUE</td>
          </thead>
          <tbody>
            {filtData.map((value, index) => {
              return (
                <tr
                  className={
                    index < receipts.length
                      ? "border-b cursor-pointer text-sm table-row"
                      : ""
                  }
                >
                  <td className="text-left">
                    {value.SALETYPE ? value.SALETYPE : ""}
                  </td>
                  <td className="text-left">
                    {value.CLIENT ? value.CLIENT : ""}
                  </td>
                  <td className="text-left">
                    {value.DIVISION ? value.DIVISION : ""}
                  </td>
                  <td className="text-right">
                    {value.BILLNO ? value.BILLNO : ""}
                  </td>
                  <td className="text-left">
                    {value.TABLENO ? value.TABLENO : ""}
                  </td>
                  <td className="text-left">
                    {value.WAITER ? value.WAITER : ""}
                  </td>
                  <td className="text-left">
                    {value.CREATEDDATE
                      ? moment(value.CREATEDDATE).format("DD/MM/YYYY")
                      : ""}
                  </td>
                  <td className="text-left">
                    {value.DATETIME
                      ? moment(value.DATETIME).format("DD/MM/YYYY HH:mm:ss")
                      : ""}
                  </td>

                  <td className="text-left">
                    {value.SHIFT ? value.SHIFT : ""}
                  </td>
                  <td className="text-left">
                    {value.SALEHOUR ? value.SALEHOUR : ""}
                  </td>
                   <td className="text-right">
                    {value?.AMOUNT
                      ? value?.AMOUNT.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "N/A"}
                  </td>
                   <td className="text-right">
                    {value?.LEVYAMOUNT
                      ? value?.LEVYAMOUNT.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "N/A"}
                  </td>
                  <td className="text-right">
                    {value?.VATAMOUNT
                      ? value?.VATAMOUNT.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "N/A"}
                  </td>
                  <td className="text-right">
                    {value?.CASHAMOUNT
                      ? value?.CASHAMOUNT.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "N/A"}
                  </td>
                  <td className="text-right">
                    {value?.MPESAMOUNT
                      ? value?.MPESAMOUNT.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "N/A"}
                  </td>
                  <td className="text-right">
                    {value?.CREDITCARDAMOUNT
                      ? value?.CREDITCARDAMOUNT.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "N/A"}
                  </td>
                  <td className="text-right">
                    {value?.RECEIPTAMOUNT
                      ? value?.RECEIPTAMOUNT.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "N/A"}
                  </td>
                  <td className="text-left">
                    {value.CASHIER ? value.CASHIER : ""}
                  </td>
                  <td className="text-left">
                    {value.CURRENCY ? value.CURRENCY : ""}
                  </td>
                  <td className="text-left">
                    {value.CATEGORY ? value.CATEGORY : ""}
                  </td>
                  <td className="text-left">
                    {value.SUBCATEGORY ? value.SUBCATEGORY : ""}
                  </td>
                  <td className="text-left">
                    {value.ITEMCODE ? value.ITEMCODE : ""}
                  </td>
                  <td className="text-left">
                    {value.ITEMNAME ? value.ITEMNAME : ""}
                  </td>
                  <td className="text-right">
                    {value?.RATEINCLUSIVE
                      ? value?.RATEINCLUSIVE.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "N/A"}
                  </td>  
                  <td className="text-right">
                    {value?.QTY
                      ? value?.QTY.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "N/A"}
                  </td>  
                  <td className="text-right">
                    {value?.ITEMVATAMOUNT
                      ? value?.ITEMVATAMOUNT.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "N/A"}
                  </td>  
                  <td className="text-right">
                    {value?.ITEMLEVYAMOUNT
                      ? value?.ITEMLEVYAMOUNT.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "N/A"}
                  </td>  
                  <td className="text-right">
                    {value?.ITEMVALUEEXCVAT
                      ? value?.ITEMVALUEEXCVAT.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "N/A"}
                  </td>  
                  <td className="text-right">
                    {value?.ITEMVALUE
                      ? value?.ITEMVALUE.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "N/A"}
                  </td>  
                </tr>
              );
            })}
          </tbody>
        </table>{" "}
      </aside>
      <h2 className="text-red-700">
        Total :{" "}
        {totalAmount
          ? totalAmount.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          : ""}
      </h2>
    </>
  );

  return (
    <>
      <Navbar />
      <DashBoardNavbar />
      <HomePageNavbarFinancials />
      {isoading ? <Loading /> : renderList}
    </>
  );
}

export default SALESREPORTDETAILED;
